import React, { Component } from "react";
import { connect } from "react-redux";
import { PagesForCaption, CaptionCodes } from "../../config/Helper";
import agencyApi from "../../api/agencyApi";
import AgencyItem from "./AgencyItem";
import Contact from "./Contact";
import Client from "./Client";
import Schedule from "./Schedule";
import News from "./News";
import * as UTILS from "../../config/utils";
import captionApi from "../../api/captionApi";
import AgencySlider from "../../components/agency/AgencySlider";
import { lang } from "../../config/lang";
import $ from "jquery/dist/jquery.js";
import ScrollToTop from "../home/ScrollToTop/ScrollToTop";

class AgencyMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            agency: null,
            medias: [],
            clients: [],
            schedules: [],
            news: [],
            sectionTitle: {},
            noData: false,
        };
        this.currentLang = props.language.lang_key;
        this.getAgency = this.getAgency.bind(this);
        this.getSectionTitles = this.getSectionTitles.bind(this);
    }

    componentWillMount() {
        this.getSectionTitles();
        this.getAgency(this.props.id);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentWillReceiveProps(newProps) {
        if (this.state.id !== parseInt(newProps.id, 10)) {
            this.setState({
                id: newProps.id,
                agency: null,
                medias: [],
                clients: [],
                schedules: [],
                news: [],
                sectionTitle: {},
                noData: false,
            });
        }
        this.getSectionTitles();
        this.getAgency(newProps.id);

        window.scrollTop("#top_banner");
        // if (this.currentLang !== newProps.language.lang_key) {
        //     this.currentLang = newProps.language.lang_key;
        // } else {
        //     window.scrollTop('#top_banner');
        // }
    }
    componentDidUpdate() {}

    getAgency(id) {
        agencyApi.getAgency(id).then((json) => {
            if (json.status === 200 && json.data) {
                const clients = [];
                const schedules = [];
                const news = [];
                json.data.clients.map((client) => {
                    if (
                        UTILS.stripTag(client.title) !== "" &&
                        client.title !== null
                    ) {
                        clients.push(client);
                    }

                    return client;
                });

                json.data.schedules.map((schedule) => {
                    if (
                        UTILS.stripTag(schedule.title) !== "" &&
                        schedule.title !== null
                    ) {
                        schedules.push(schedule);
                    }
                    return schedule;
                });

                json.data.news.map((newsItem) => {
                    if (
                        UTILS.stripTag(newsItem.title) !== "" &&
                        newsItem.title !== null
                    ) {
                        news.push(newsItem);
                    }
                    return newsItem;
                });

                this.setState({
                    agency: json.data,
                    medias: json.data.medias,
                    clients: clients,
                    schedules: schedules,
                    news: news,
                });
            } else if (json.status === 200 && json.data === "") {
                this.setState({
                    noData: true,
                });
            } else {
                if (json.status === 620) {
                } else {
                    this.setState({
                        noData: true,
                    });
                }
            }
        });
    }

    getSectionTitles() {
        captionApi.getCaptions("agency_detail").then((json) => {
            if (json.status === 200) {
                this.setState({
                    sectionTitle: json.data,
                });
            } else {
                // store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        });
    }

    render() {
        return (
            <div>
                {this.state.agency !== null && (
                    <AgencyItem
                        agency={this.state.agency}
                        medias={this.state.medias}
                    />
                )}
                <section className="ftco-services-2 ftco-no-pt">
                    <div className="container">
                        <div className="row">
                            {this.state.news.length > 0 && (
                                <div className="col-lg-12 col-md-12">
                                    <News
                                        news={this.state.news}
                                        agency={this.state.agency}
                                        newsCaption={
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_news")
                                            ] !== undefined &&
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_news")
                                            ].title !== null &&
                                            $.trim(
                                                this.state.sectionTitle[
                                                    CaptionCodes[
                                                        PagesForCaption.indexOf(
                                                            "agency_detail"
                                                        )
                                                    ].indexOf("agency_news")
                                                ].title
                                            ) !== ""
                                                ? this.state.sectionTitle[
                                                      CaptionCodes[
                                                          PagesForCaption.indexOf(
                                                              "agency_detail"
                                                          )
                                                      ].indexOf("agency_news")
                                                  ].title
                                                : ""
                                        }
                                    />
                                    <hr className="solid tall" />
                                </div>
                            )}
                        </div>
                        <div className="row">
                            {this.state.schedules.length > 0 && (
                                <div className="col-lg-12 col-md-12">
                                    <Schedule
                                        schedules={this.state.schedules}
                                        scheduleCaption={
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_schedule")
                                            ] !== undefined &&
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_schedule")
                                            ].title !== undefined &&
                                            $.trim(
                                                this.state.sectionTitle[
                                                    CaptionCodes[
                                                        PagesForCaption.indexOf(
                                                            "agency_detail"
                                                        )
                                                    ].indexOf("agency_schedule")
                                                ].title
                                            ) !== ""
                                                ? this.state.sectionTitle[
                                                      CaptionCodes[
                                                          PagesForCaption.indexOf(
                                                              "agency_detail"
                                                          )
                                                      ].indexOf(
                                                          "agency_schedule"
                                                      )
                                                  ].title
                                                : ""
                                        }
                                    />
                                    <hr className="solid tall" />
                                </div>
                            )}
                        </div>
                        <div className="row">
                            {this.state.agency !== null && (
                                <div className="col-lg-6 col-md-12">
                                    <Contact
                                        agency={this.state.agency}
                                        contactCaption={
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_about_us")
                                            ] !== undefined &&
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_about_us")
                                            ].title !== null &&
                                            $.trim(
                                                this.state.sectionTitle[
                                                    CaptionCodes[
                                                        PagesForCaption.indexOf(
                                                            "agency_detail"
                                                        )
                                                    ].indexOf("agency_about_us")
                                                ].title
                                            ) !== ""
                                                ? this.state.sectionTitle[
                                                      CaptionCodes[
                                                          PagesForCaption.indexOf(
                                                              "agency_detail"
                                                          )
                                                      ].indexOf(
                                                          "agency_about_us"
                                                      )
                                                  ].title
                                                : ""
                                        }
                                    />
                                </div>
                            )}

                            {this.state.clients.length > 0 && (
                                <div className="col-lg-6 col-md-12">
                                    <Client
                                        clients={this.state.clients}
                                        clientCaption={
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_clients")
                                            ] !== undefined &&
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf("agency_clients")
                                            ].title !== null &&
                                            $.trim(
                                                this.state.sectionTitle[
                                                    CaptionCodes[
                                                        PagesForCaption.indexOf(
                                                            "agency_detail"
                                                        )
                                                    ].indexOf("agency_clients")
                                                ].title
                                            ) !== ""
                                                ? this.state.sectionTitle[
                                                      CaptionCodes[
                                                          PagesForCaption.indexOf(
                                                              "agency_detail"
                                                          )
                                                      ].indexOf(
                                                          "agency_clients"
                                                      )
                                                  ].title
                                                : ""
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {(this.state.agency !== null &&
                            ((UTILS.stripTag(this.state.agency.others) !== "" &&
                                this.state.agency.others !== null) ||
                                (this.state.agency.phone !== "" &&
                                    this.state.agency.phone !== null) ||
                                (this.state.agency.fax !== "" &&
                                    this.state.agency.fax !== null) ||
                                (this.state.agency.email !== "" &&
                                    this.state.agency.email !== null))) ||
                        this.state.clients.length > 0 ? (
                            <div className="pt-4 "></div>
                        ) : (
                            ""
                        )}
                    </div>
                </section>
                {this.state.noData === true && (
                    <div className="container ">
                        <div className="row mt-4 pt-4">
                            <h4 className="mt-4 mb-4">{lang("no_data")}</h4>
                        </div>
                    </div>
                )}
                <section
                    className="ftco-section2 testimony-section mt-4"
                    id="agency-section"
                >
                    <div className="container">
                        <div className="row"></div>
                        <div className="row justify-content-start">
                            <div className="col-md-12 heading-section ftco-animate">
                                <AgencySlider
                                    isPart={false}
                                    title={
                                        this.state.sectionTitle !== undefined &&
                                        this.state.sectionTitle[
                                            CaptionCodes[
                                                PagesForCaption.indexOf(
                                                    "agency_detail"
                                                )
                                            ].indexOf("agency_other_agencies")
                                        ] !== undefined &&
                                        this.state.sectionTitle[
                                            CaptionCodes[
                                                PagesForCaption.indexOf(
                                                    "agency_detail"
                                                )
                                            ].indexOf("agency_other_agencies")
                                        ].title !== null &&
                                        $.trim(
                                            this.state.sectionTitle[
                                                CaptionCodes[
                                                    PagesForCaption.indexOf(
                                                        "agency_detail"
                                                    )
                                                ].indexOf(
                                                    "agency_other_agencies"
                                                )
                                            ].title
                                        ) !== ""
                                            ? this.state.sectionTitle[
                                                  CaptionCodes[
                                                      PagesForCaption.indexOf(
                                                          "agency_detail"
                                                      )
                                                  ].indexOf(
                                                      "agency_other_agencies"
                                                  )
                                              ].title
                                            : ""
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <ScrollToTop />
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
    };
}

export default connect(mapStateToProps)(AgencyMain);
